import React, { useState } from "react";
import ProfilePic from "../sidebar/ProfilePic";
import Sidebar from "../sidebar/Sidebar";
import { Link, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import CampaignHeader from "./CampaignHeader";
import CampaignBasicInfo from "./CampaignBasicInfo";
import CampaignPaymentInfo from "./CampaignPaymentInfo";
import useGetCampaignById from "../../utils/useGetCampaignById";

const CampaignDetails = ({ onLogout }) => {
  const params = useParams();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { id } = params;
  const [campaignData, refreshData, isLoading] = useGetCampaignById(
    id,
    page,
    rowsPerPage
  );
  return (
    <div className="home_main">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel" style={{ backgroundColor: "#f4f8fb" }}>
          <div className="dashboard_main">
            <div className="infl_header_top">
              <div className="dashboard_header infl_head">
                <Link to={"/"} className="go_back">
                  <IoIosArrowRoundBack className="icon" />
                </Link>
                <div className="logout_box">
                  <ProfilePic onLogout={onLogout} />
                </div>
              </div>
            </div>
            <div className="container">
              <CampaignHeader campaignData={campaignData?.campaign} />
              <CampaignBasicInfo campaignData={campaignData?.campaign} />
              <CampaignPaymentInfo campaignData={campaignData?.campaign} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignDetails;
